import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
	selector: 'app-ask-snoozing-dialog',
	templateUrl: './ask-snoozing-dialog.component.html',
	styleUrls: ['./ask-snoozing-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskSnoozingDialogComponent implements OnInit {
	public timeControl = new FormControl('', [Validators.required]);
	public disablePermanently = new FormControl(false, [Validators.required, Validators.requiredTrue]);

	public isActive = false;
	constructor(
		public dialogRef: MatDialogRef<AskSnoozingDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { text: string; isActive: boolean }
	) {
		if (data?.isActive) {
			this.isActive = data.isActive;
		} else {
			this.isActive = false;
		}
		console.log(data);
		this.timeControl.valueChanges.subscribe(v => {
			console.log(v);
		});
		this.patchForm();
	}
	private patchForm() {
		try {
			const time = moment();
			this.timeControl.patchValue(time.endOf('day').format('YYYY-MM-DDTHH:mm'));
		} catch (e) {}
	}
	ngOnInit() {}
	close() {
		this.dialogRef.close({ value: false });
	}
	agreeOn() {
		this.dialogRef.close({ value: true });
	}
	agree(value: number) {
		this.dialogRef.close({
			value: true,
			snoozed: moment().add(value, 'hour'),
		});
	}
	agreeWithSnoozing() {
		console.log(moment(this.timeControl.value));
		this.dialogRef.close({
			value: true,
			snoozed: moment(this.timeControl.value),
		});
	}
}
